import {
  faCheck,
  faCircleNotch,
  faTimes,
  faTrash,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { Sub2Typography } from '../../../Typography';

import StyledContainer from './StyledContainer';
import StyledIcon from './StyledIcon';

import theme from '$/assets/theme';

interface ISelectedFileProps {
  name: string;
  progress: number;
  cancelUpload: () => void;
  processing?: boolean;
}

const SelectedFile = (props: ISelectedFileProps) => (
  <StyledContainer>
    {props.progress === 100 ? (
      <StyledIcon background="brandGreen" color="white">
        {props.processing ? (
          <FontAwesomeIcon icon={faCircleNotch} spin />
        ) : (
          <FontAwesomeIcon icon={faCheck} />
        )}
      </StyledIcon>
    ) : (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr auto',
          alignItems: 'center',
          gridGap: '12px',
        }}
      >
        <div style={{ width: '32px', height: '32px' }}>
          <CircularProgressbar
            value={props.progress}
            strokeWidth={5}
            background
            styles={buildStyles({
              strokeLinecap: 'butt',
              trailColor: theme.colors.brandGreen10,
              pathColor: theme.colors.brandGreen75,
              backgroundColor: theme.colors.brandGreen10,
            })}
          />
        </div>
        <Sub2Typography color="brandGreen" bold style={{ width: '50px' }}>
          {props.progress}%
        </Sub2Typography>
        <span>|</span>
      </div>
    )}

    <Sub2Typography>{props.name}</Sub2Typography>

    {props.progress === 100 ? (
      <StyledIcon
        background="grey1"
        color={!props.processing ? 'grey7' : 'white'}
        cursor={!props.processing ? 'pointer' : 'default'}
        onClick={!props.processing ? props.cancelUpload : () => null}
      >
        <FontAwesomeIcon icon={faTrash} />
      </StyledIcon>
    ) : (
      <StyledIcon
        background="grey1"
        color="grey7"
        cursor="pointer"
        onClick={props.cancelUpload}
      >
        <FontAwesomeIcon icon={faTimes} />
      </StyledIcon>
    )}
  </StyledContainer>
);

export default SelectedFile;
